import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  padding: 10px 12px;
  align-items: flex-start;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  gap: 10px;
`;

export const ProductImage = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.lightGrayOpacity};
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;

  h6 {
    font-size: 13px;
    font-weight: 600;
    margin: 0;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
`;

export const SubPrice = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const Price = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.success};
`;

export const Quantity = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textSecondary};
  background-color: ${({ theme }) => theme.colors.lightGrayOpacity};
  padding: 2px 8px;
  border-radius: 6px;
  white-space: nowrap;
`;
